import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=82eb8f6c&scoped=true&"
import script from "./TextQuestion.vue?vue&type=script&lang=js&"
export * from "./TextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=82eb8f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eb8f6c",
  null
  
)

export default component.exports